export default __webpack_public_path__ + "static/media/logo_dark.e69aa638.png";